import { fetchUser as fetchUserAPI } from "../api";

export const fetchUserAction = async (
  jwt,
  setUser,
  setAssignment,
  setQuestion
) => {
  const user = await fetchUserAPI(jwt);
  setUser(user.data);
  setAssignment(user?.data?.classes[0]?.assignments[0]);
  setQuestion(user?.data?.classes[0]?.assignments[0]?.questions[0]);
};
